import axios from 'axios';

// CRA proxy is configured in package.json → "proxy": "http://localhost:5000"
// In production set REACT_APP_API_URL to your backend domain.
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 120_000,
});

// ── Helpers ───────────────────────────────────────────────────────────────────

function authHeader(token) {
  return { Authorization: `Bearer ${token}` };
}

// ── Payment ───────────────────────────────────────────────────────────────────

/**
 * Create a Stripe PaymentIntent.
 * Returns { clientSecret, paymentIntentId, amount, currency }
 */
export async function createPaymentIntent({ reportType, plate, state, email, firstName, lastName }) {
  //console.log('hello');
  //console.log(reportType);
  //console.log(plate);
  //console.log(state);
  //console.log(email);
  //console.log(firstName);
  //console.log(lastName);
  const { data } = await api.post('/api/payment/create-intent', {
    reportType,
    plate,
    state,
    email,
    firstName,
    lastName,
  });
  return data;
}

//export async function manualcardcreatePaymentIntent({ payment_method_id, amount, currency }) {
export async function manualcardcreatePaymentIntent({ payment_method_id, reportType, plate, state, email, firstName, lastName }) {
//console.log('hello');
  //console.log(reportType);
  //console.log(plate);
  //console.log(state);
  //console.log(email);
  //console.log(firstName);
  //console.log(lastName);
  console.log('api.js - manualcardcreatePaymentIntent()');
  console.log('payment_method_id :'+ payment_method_id);
  console.log('reportType :'+ reportType);
  console.log('plate :'+ plate);
  console.log('state :'+ state);
  console.log('email :'+ email);
  console.log('firstName :'+ firstName);
  console.log('lastName :'+ lastName);
  
  const { data } = await api.post('/api/payment/create-manualcard-intent', {
    payment_method_id,
    reportType,
    plate,
    state,
    email,
    firstName,
    lastName
  });
  return data;
}

/**
 * Complete the payment after Stripe.js confirms.
 * Returns { token, orderId }
 */
export async function completePayment({ paymentIntentId, reportType, plate, state, email }) {
  //console.log('export async function completePayment({ paymentIntentId, reportType, plate, state, email }) {');
  //console.log('api.js paymentIntentId :'+ paymentIntentId);
  //console.log('api.js reportType :'+ reportType);
  //console.log('api.js plate :'+ plate);
  //console.log('api.js state :'+ state);
  //console.log('api.js email :'+ email);
  const { data } = await api.post('/api/payment/complete', {
    paymentIntentId,
    reportType,
    plate,
    state,
    email,
  });
  return data;
}

// ── Report ────────────────────────────────────────────────────────────────────

/**
 * Fetch the report data. Requires a valid JWT.
 * Returns the full order + report payload.
 */
export async function fetchReport(token) {
  //console.log('export async function fetchReport(token) {');
  //console.log('api.js token :'+ token);
  const { data } = await api.get('/api/report', {
    headers: authHeader(token),
  });
  return data;
}

/**
 * Build a URL to stream the PDF certificate.
 * The browser handles the download via an <a> tag or window.open().
 */
export function getCertificateUrl(token) {
  return `${BASE_URL}/api/report/certificate?token=${encodeURIComponent(token)}`;
}

/**
 * Download the PDF certificate directly (uses fetch so we can pass the Auth header).
 * Returns a Blob.
 */
export async function downloadCertificate(token, pprstransactionid) {
  //console.log('api.js - export async function downloadCertificate(token) {');
  //console.log('api.js - token :'+ token);
  //console.log('api.js - pprstransactionid :'+ pprstransactionid);

  //const { data } = await api.get('/api/report/customcertificate', {
    //headers: authHeader(token)
  //});

  const customcertificate_result = await api.get('/api/report/customcertificate', {
    headers: authHeader(token)
  });

  //console.log('api.js - downloadCertificate - data: ' + customcertificate_result);

  //if (!data.ok) {
    //console.log('api.js - downloadCertificate - if (!data.ok) {'); 
    //const body = await data.json().catch(() => ({}));
    //throw new Error(body.error || 'Failed to download certificate');
 //}

 //console.log('api.js2 - downloadCertificate - data2: ' + customcertificate_result);
 console.log('api.js2 - downloadCertificate - data2: ');
 console.log(customcertificate_result); 
 return customcertificate_result;
  //const response = await fetch(`${BASE_URL}/api/report/certificate`, {
    //headers: { Authorization: `Bearer ${token}` },
  //});
  
  //const response = await fetch(`https://api.dev.infoagent.com.au/ivds/v1/au/vehicle-report/ppsr/${pprstransactionid}/certificate`, {
    //headers: { Authorization: `Bearer ${token}` },
  //});
  //if (!response.ok) {
    //const body = await response.json().catch(() => ({}));
    //throw new Error(body.error || 'Failed to download certificate');
 // }
  //return response.blob();
}
